import '@/app.css';
import '@/app/lib/i18next';

import Bugsnag from '@bugsnag/js';
import { isAxiosError } from 'axios';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { getEnv } from '@/app/conf/env';
import checkBrowser from '@/app/lib/check-browser';
import { AppRouter } from '@/app/router';
import AppErrorBoundary from '@/shared/components/errors/app-error-boundary';
import { UnhandledErrorDisplay } from '@/shared/components/errors/unhandled-error-display';

const env = getEnv();
if (env.BUGSNAG_API_KEY && !Bugsnag.isStarted?.()) {
  Bugsnag.start({
    apiKey: env.BUGSNAG_API_KEY,
    appVersion: env.APP_VERSION,
    releaseStage: env.APP_ENV,
    onError: (event) => {
      if (isAxiosError(event.originalError)) return false;
    }
  });
}

const browser = checkBrowser();
if (browser.unsupported) {
  document.getElementById('unsupported-browser')!.style.display = 'block';
} else {
  const rootElement = document.getElementById('root')!;

  if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <AppErrorBoundary fallback={UnhandledErrorDisplay}>
          <AppRouter />
        </AppErrorBoundary>
      </React.StrictMode>
    );
  }
}
